import { render, staticRenderFns } from "./fusion.vue?vue&type=template&id=0aa19c79&scoped=true&"
import script from "./fusion.vue?vue&type=script&lang=js&"
export * from "./fusion.vue?vue&type=script&lang=js&"
import style0 from "./fusion.vue?vue&type=style&index=0&id=0aa19c79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa19c79",
  null
  
)

export default component.exports